import { useTranslation } from 'react-i18next';

import { Header } from '../components/index.jsx';
import { SoilSensor } from '../components/SoilSensor/index.jsx';
import { getSidebarLinksMap } from '../utils/ui';

const SoilSensorPage = () => {
  const { t } = useTranslation();
  const SidebarLinksMap = getSidebarLinksMap(t);

  return (
    <>
      <Header title={SidebarLinksMap.soilSensor.title} t={t} />
      <main className="main">
        <SoilSensor t={t} />
      </main>
    </>
  );
};

export default SoilSensorPage;
